import { css } from 'styled-components';

export const removeOutline = css`
  outline: none;

  &::-moz-focus-inner {
    border: none;
  }
`;
